import { Component, OnInit, Input, Output, OnChanges, EventEmitter } from '@angular/core';

@Component({
    selector: 'dialog-component',
    templateUrl: './dialog.component.html',
    styleUrls: [ './popup.component.scss']
})

export class DialogComponent implements OnInit {
    @Input() visible: boolean;
    // @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor() { }
    ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/components/dialog/dialog.component.ts